import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAppState } from '@myStore/app.state';
import {
  ESalesViewActions,
  GetAllDiscountsFailure,
  GetAllDiscountsRequest,
  GetAllDiscountsSuccess,
  GetAllPaymentsFailure,
  GetAllPaymentsRequest,
  GetAllPaymentsSuccess,
  GetAllSalesDealsFailure,
  GetAllSalesDealsRequest,
  GetAllSalesDealsSuccess,
  GetApplicantsRequest,
  GetApplicantsSFailure,
  GetApplicantsSuccess,
  GetContractCredentialsFailure,
  GetContractCredentialsRequest,
  GetContractCredentialsSuccess,
  GetDealHistoryFailure,
  GetDealHistoryRequest,
  GetDealHistorySuccess,
  GetEnrolleesFailure,
  GetEnrolleesInPresentationFailure,
  GetEnrolleesInPresentationRequest,
  GetEnrolleesInPresentationSuccess,
  GetEnrolleesRequest,
  GetEnrolleesSuccess,
  GetFullViewOfPaymentFailure,
  GetFullViewOfPaymentRequest,
  GetFullViewOfPaymentSuccess,
  GetLeadContractFailure,
  GetLeadContractRequest,
  GetLeadContractSuccess,
  GetLeadDocumentsFailure,
  GetLeadDocumentsRequest,
  GetLeadDocumentsSuccess,
  GetLeadFailure,
  GetLeadInQRFailure,
  GetLeadInQRRequest,
  GetLeadInQRSuccess,
  GetLeadRequest,
  GetLeadsFailure,
  GetLeadsRequest,
  GetLeadsSuccess,
  GetLeadStatusesFailure,
  GetLeadStatusesRequest,
  GetLeadStatusesSuccess,
  GetLeadSuccess,
  GetOneDealByIDFailure,
  GetOneDealByIDRequest,
  GetOneDealByIDSuccess,
  GetPresentationInfoFailure,
  GetPresentationInfoRequest,
  GetPresentationInfoSuccess,
  GetTaskFailure,
  GetTaskFilesFailure,
  GetTaskFilesRequest,
  GetTaskFilesSuccess,
  GetTaskRequest,
  GetTasksFailure,
  GetTasksRequest,
  GetTasksSuccess,
  GetTaskSuccess,
  GetTokenForLeadFormFailure,
  GetTokenForLeadFormRequest,
  GetTokenForLeadFormSuccess,
} from '@myStore/sales-view/sales-view.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { SalesViewService } from '@services/sales-view/sales-view.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class SalesViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _router: Router,
    private _toastr: ToastrService,
    private _salesViewService: SalesViewService
  ) {}

  getTokenForLeadForm$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetTokenForLeadFormRequest>(
          ESalesViewActions.GetTokenForLeadFormRequest
        ),
        switchMap(action => {
          return this._salesViewService
            .getTokenForLeadForm(action?.options)
            .pipe(
              map(data => {
                this._store.dispatch(new GetTokenForLeadFormSuccess(data));
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new GetTokenForLeadFormFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  getPresentationInfo$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetPresentationInfoRequest>(
          ESalesViewActions.GetPresentationInfoRequest
        ),
        switchMap(() => {
          return this._salesViewService.getPresentationInfo().pipe(
            map(data => {
              this._store.dispatch(new GetPresentationInfoSuccess(data));
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new GetPresentationInfoFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getEnrollees$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetEnrolleesRequest>(ESalesViewActions.GetEnrolleesRequest),
        switchMap(action => {
          return this._salesViewService
            .getEnrollees(action.options?.qparams)
            .pipe(
              map(data => {
                this._store.dispatch(new GetEnrolleesSuccess(data));
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new GetEnrolleesFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  getEnrolleesInPresentation$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetEnrolleesInPresentationRequest>(
          ESalesViewActions.GetEnrolleesInPresentationRequest
        ),
        switchMap(action => {
          return this._salesViewService
            .getEnrolleesInPresentation(action.options?.qparams)
            .pipe(
              map(data => {
                this._store.dispatch(
                  new GetEnrolleesInPresentationSuccess(data)
                );
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new GetEnrolleesInPresentationFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  getLeads$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetLeadsRequest>(ESalesViewActions.GetLeadsRequest),
        switchMap(action => {
          return this._salesViewService.getLeads(action.options?.qparams).pipe(
            map(data => {
              this._store.dispatch(new GetLeadsSuccess(data));
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new GetLeadsFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getLeadInQRForm$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetLeadInQRRequest>(ESalesViewActions.GetLeadInQRRequest),
        switchMap(action => {
          return this._salesViewService
            .getLeadInQR(action.options?.qparams)
            .pipe(
              map(data => {
                this._store.dispatch(new GetLeadInQRSuccess(data));
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new GetLeadInQRFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  getLead$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetLeadRequest>(ESalesViewActions.GetLeadRequest),
        switchMap(action => {
          return this._salesViewService
            .getLead(action.id, action.options?.qparams)
            .pipe(
              map(data => {
                this._store.dispatch(new GetLeadSuccess(data));
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new GetLeadFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  getLeadStatuses$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetLeadStatusesRequest>(
          ESalesViewActions.GetLeadStatusesRequest
        ),
        switchMap(() => {
          return this._salesViewService.getLeadStatuses().pipe(
            map(data => {
              this._store.dispatch(new GetLeadStatusesSuccess(data));
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new GetLeadStatusesFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getTasks$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetTasksRequest>(ESalesViewActions.GetTasksRequest),
        switchMap(action => {
          return this._salesViewService.getTasks(action?.options).pipe(
            map(data => {
              this._store.dispatch(new GetTasksSuccess(data));
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new GetTasksFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getTask$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetTaskRequest>(ESalesViewActions.GetTaskRequest),
        switchMap(action => {
          return this._salesViewService.getTask(action.id).pipe(
            map(data => {
              this._store.dispatch(new GetTaskSuccess(data));
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new GetTaskFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getDealHistoryById$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetDealHistoryRequest>(ESalesViewActions.GetDealHistoryRequest),
        switchMap(action => {
          return this._salesViewService.getDealHistoryById(action.deal_id).pipe(
            map(data => {
              this._store.dispatch(new GetDealHistorySuccess(data.results));
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new GetDealHistoryFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getTaskFiles$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetTaskFilesRequest>(ESalesViewActions.GetTaskFilesRequest),
        switchMap(action => {
          return this._salesViewService.getTaskFiles(action?.options).pipe(
            map(data => {
              this._store.dispatch(new GetTaskFilesSuccess(data));
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new GetTaskFilesFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getContractCredentials$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetContractCredentialsRequest>(
          ESalesViewActions.GetContractCredentialsRequest
        ),
        switchMap(() => {
          return this._salesViewService.getContractCredentials().pipe(
            map(data => {
              this._store.dispatch(new GetContractCredentialsSuccess(data));
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(
                new GetContractCredentialsFailure(err.error)
              );
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getLeadDocuments$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetLeadDocumentsRequest>(
          ESalesViewActions.GetLeadDocumentsRequest
        ),
        switchMap(action => {
          return this._salesViewService.getLeadDocuments(action.lead_id).pipe(
            map(data => {
              this._store.dispatch(new GetLeadDocumentsSuccess(data));
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new GetLeadDocumentsFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getLeadContract = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetLeadContractRequest>(
          ESalesViewActions.GetLeadContractRequest
        ),
        switchMap(action => {
          return this._salesViewService.getLeadContract(action.lead_id).pipe(
            map(data => {
              this._store.dispatch(new GetLeadContractSuccess(data));
            }),
            catchError(err => {
              this._toastr.error(
                `Контракт не создался так как : ${err.error.detail}`,
                '',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetLeadContractFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getAllSalesDeals = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetAllSalesDealsRequest>(
          ESalesViewActions.GetAllSalesDealsRequest
        ),
        switchMap(data => {
          return this._salesViewService.getAllSalesDeals(data?.options).pipe(
            map(data => {
              this._store.dispatch(new GetAllSalesDealsSuccess(data));
            }),
            catchError(err => {
              this._store.dispatch(new GetAllSalesDealsFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getOneDealByID = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetOneDealByIDRequest>(ESalesViewActions.GetOneDealByIDRequest),
        switchMap(data => {
          return this._salesViewService.getOneDealById(data.deal_id).pipe(
            map(data => {
              this._store.dispatch(new GetOneDealByIDSuccess(data));
            }),
            catchError(err => {
              this._store.dispatch(new GetOneDealByIDFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getAllPaymentNotes$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetAllPaymentsRequest>(ESalesViewActions.GetAllPaymentsRequest),
        switchMap(data => {
          return this._salesViewService.getAllPayments(data?.queries).pipe(
            map(data => {
              this._store.dispatch(new GetAllPaymentsSuccess(data));
            }),
            catchError(err => {
              this._store.dispatch(new GetAllPaymentsFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getFullViewPaymentsNotes$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetFullViewOfPaymentRequest>(
          ESalesViewActions.GetFullViewOfPaymentRequest
        ),
        switchMap(data => {
          return this._salesViewService
            .getFullViewOfPayment(data.payment_id)
            .pipe(
              map(data => {
                this._store.dispatch(new GetFullViewOfPaymentSuccess(data));
              }),
              catchError(err => {
                this._store.dispatch(
                  new GetFullViewOfPaymentFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  getAllDiscounts$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetAllDiscountsRequest>(
          ESalesViewActions.GetAllDiscountsRequest
        ),
        switchMap(() => {
          return this._salesViewService.getAllDiscounts().pipe(
            map(data => {
              this._store.dispatch(new GetAllDiscountsSuccess(data));
            }),
            catchError(err => {
              if (err.error.detail) {
                this._toastr.error(err.error.detail, '', {
                  timeOut: 3500,
                });
              }
              this._store.dispatch(new GetAllDiscountsFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getApplicants$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetApplicantsRequest>(ESalesViewActions.GetApplicantsRequest),
        switchMap(() => {
          return this._salesViewService.getAllApplicants().pipe(
            map(data => {
              this._store.dispatch(new GetApplicantsSuccess(data));
            }),
            catchError(err => {
              if (err.error.detail) {
                this._toastr.error(err.error.detail, '', {
                  timeOut: 3500,
                });
              }
              this._store.dispatch(new GetApplicantsSFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
